export default [
    {
        //内销发货
        path: '/dingd/orderNxSend',
        component: () => import( '@/views/dingdmain/orderNxSend.vue'),
        meta: {
            title: '内销发货确认',
            isTabsPage: true,
            keepAlive: true
        }
    },
    {
        //外销发货
        path: '/dingd/orderWxSend',
        component: () => import( '@/views/dingdmain/orderWxSend.vue'),
        meta: {
            title: '外销发货确认',
            isTabsPage: true,
            keepAlive: true
        }
    },
    {
        //外销发货(这个是外销订单管理员用-额外的功能和字段)
        path: '/dingd/orderNxSend-wx',
        component: () => import( '@/views/dingdmain/orderNxSend-wx.vue'),
    },
    {
        //发货信息
        path: '/dingd/orderInfo',
        component: () => import( '@/views/dingdmain/orderInfo.vue'),
        meta: {
            title: '发货信息',
            isTabsPage: true,
            keepAlive: true
        }
    },
    {
        //订单全流程
        path: '/dingd/orderProcess',
        component: () => import( '@/views/dingdmain/orderProcess.vue'),
        meta: {keepAlive:true,
            title: '订单全流程',
            isTabsPage: true}
    },
    {
        //内销订单列表
        path: '/dingd/dingdmainlist',
        component: () => import( '@/views/dingdmain/dingd-list.vue'),
        meta: {
            title: '订单列表(内销)',
            isTabsPage: true
        }
    },
    {
        //内销订单列表--上海
        path: '/dingd/dingdlistshanghai',
        component: () => import( '@/views/dingdmain/dingd-shanghai.vue'),
        meta: {
            title: '订单管理(上海)',
            isTabsPage: true,
            keepAlive: true
        }
    },
    {
        //外销订单列表
        path: '/dingd/dingdwxlist',
        component: () => import( '@/views/dingdmain/dingdWxlist.vue'),
        meta: {
            title: '订单列表(外销)',
            isTabsPage: true,
            keepAlive: false
        }
    },
    {
        //外销订单列表
        path: '/dingd/dingdwxlistUsa',
        component: () => import( '@/views/dingdmain/dingdWxlistUsa.vue'),
        meta: {
            title: '订单列表(海外标准)',
            isTabsPage: true,
            keepAlive: false
        }
    },
    {
        //外销他人审核
        path: '/dingdmain/orderWxOtherShenpi',
        component: () => import( '@/views/dingdmain/orderWxOtherShenpi.vue'),
    },
    {
        //发货计划
        path: '/dingd/deliveryPlanList',
        component: () => import( '@/views/dingdmain/deliveryPlanList.vue'),
        meta: {
            title: '发货计划',
            isTabsPage: true,
            keepAlive: true
        }
    },
    {
        //元析发货计划
        path: '/dingd/yuanxiRecord',
        component: () => import( '@/views/dingdmain/yuanxiRecord.vue'),
        meta: {
            title: '发货计划(元析)',
            isTabsPage: true,
            keepAlive: true
        }
    },
    {
        //用车申请
        path: '/dingd/deliveryCarList',
        component: () => import( '@/views/dingdmain/deliveryCarList.vue'),
        meta: {
            title: '用车申请',
            isTabsPage: true,
            keepAlive: true
        }
    },
    {
        //发货计划查看
        path: '/dingd/checkFhjhOrder',
        component: () => import( '@/views/dingdmain/checkFhjhOrder.vue'),
    },
    {
        //发货计划查看
        path: '/dingd/updateFhjhOrder',
        component: () => import( '@/views/dingdmain/updateFhjhOrder.vue'),
    },

    {
        //发货计划创建f
        path: '/dingd/createFhjhOrder',
        component: () => import( '@/views/dingdmain/createFhjhOrder.vue'),
    },
    {
        //用车申请创建
        path: '/dingd/createCarOrder',
        component: () => import( '@/views/dingdmain/createCarOrder.vue'),
    },
    {
        //用车申请查看
        path: '/dingd/checkCarOrder',
        component: () => import( '@/views/dingdmain/checkCarOrder.vue'),
    },
    {
        //用车申请查看
        path: '/dingd/updateCarOrder',
        component: () => import( '@/views/dingdmain/updateCarOrder.vue'),
    },
    {
        //外销订单上传凭证列表
        path: '/dingd/dingdwxlist-up',
        component: () => import( '@/views/dingdmain/dingdWxlist-up.vue'),
        meta: {
            title: '外销订单上传凭证',
            isTabsPage: true,
            keepAlive: true
        }
    },
    {
        //订单列表
        path: '/dingd/dingdProductslist',
        component: () => import( '@/views/dingdmain/dingdProductslist.vue'),
    },
    {
        //创建订单
        path: '/dingd/createNxOrder',
        component: () => import( '@/views/dingdmain/createNxOrder.vue'),
    },

    {
        //创建1+N订单
        path: '/dingd/createNxOrder1+N',
        component: () => import( '@/views/dingdmain/createNxOrder1+N.vue'),
    },
    {
        //创建外销租赁订单
        path: '/dingd/createNwSaleOrder',
        component: () => import( '@/views/dingdmain/createNwSaleOrder.vue'),
    },
    {
        //创建退货订单
        path: '/dingd/createNxThOrder',
        component: () => import( '@/views/dingdmain/createNxThOrder.vue'),
    },
    {
        //漏斗界面 创建订单
        path: '/dingd/createNxOrder3',
        component: () => import( '@/views/dingdmain/createNxOrder3.vue'),
    },
    {
        //创建外贸订单
        path: '/dingd/createWMOrder',
        component: () => import( '@/views/dingdmain/createWMOrder.vue'),
    },
    {
        //创建外贸订单
        path: '/dingd/createWMOverseaOrder',
        component: () => import( '@/views/dingdmain/createWMOverseaOrder.vue'),
    },
    {
        //创建6200独立外销订单
        path: '/dingd/createBeiHuoOrder',
        component: () => import( '@/views/dingdmain/createBeiHuoOrder.vue'),
    },
    {
        //9390或者9370卖给6200的销售订单
        path: '/dingd/createHKOrder',
        component: () => import( '@/views/dingdmain/createToHKOrder.vue'),
    },
    {
        //外销9390或者9370卖给6200订单审批页面
        path: '/dingdmain/orderWxToHKshenpi',
        component: () => import( '@/views/dingdmain/orderWxToHKshenpi.vue'),
    },
    {
        //海外销售订单
        path: '/dingd/createWxOrderSales',
        component: () => import( '@/views/dingdmain/createWxOrderSales.vue'),
    },
    {
        //海外销售订单审批
        path: '/dingdmain/orderWxSalesShenpi',
        component: () => import( '@/views/dingdmain/orderWxSalesShenpi.vue'),
    },
    {
        //创建外销订单
        path: '/dingd/createWxOrder',
        component: () => import( '@/views/dingdmain/createWxOrder.vue'),
    },
    {
        //创建外销标准订单
        path: '/dingd/createWxOrderBZ',
        component: () => import( '@/views/dingdmain/createWxOrderBZ.vue'),
    },

    {
        //创建外销订单美国医疗
        path: '/dingd/createWxOrderUsa',
        component: () => import( '@/views/dingdmain/createWxOrderUsa.vue'),
    },
        //创建海外订单--44U0
    {
        path: '/dingd/createOverseaOrder',
        component: () => import( '@/views/dingdmain/createOverseaOrder.vue'),
    },

    {
        //免费订单销售组织6200
        path: '/dingd/createWxOrder6200',
        component: () => import( '@/views/dingdmain/createWxOrder6200.vue'),
    },
    {
        //创建上海订单
        path: '/dingd/createShanghOrder',
        component: () => import( '@/views/dingdmain/createShanghOrder.vue'),
    },
    {
        //内销订单审批页面
        path: '/dingdmain/orderYdgshenpi',
        component: () => import( '@/views/dingdmain/orderYdgshenpi.vue'),
    },
    {
        //液氮罐订单审批页面
        path: '/dingdmain/orderNxshenpi',
        component: () => import( '@/views/dingdmain/orderNxshenpi.vue'),
    },
    {
        //外销订单审批页面
        path: '/dingdmain/orderWxshenpi',
        component: () => import( '@/views/dingdmain/orderWxshenpi.vue'),
    },
    {
         //外销订单审批页面
         path: '/dingdmain/orderWxshenpiKill',
         component: () => import( '@/views/dingdmain/orderWxshenpiKill.vue'),
     },
    {
        //上海订单审批页面
        path: '/dingdmain/orderShshenpi',
        component: () => import( '@/views/dingdmain/orderShshenpi.vue'),
    },
	{
	    //创建内销服务类-标准订单
	    path: '/dingd/createFuwuOrder',
	    component: () => import( '@/views/dingdmain/createFuwuOrder.vue'),
	},
    {
        //创建内销服务类-标准订单
        path: '/dingd/createMfFuwuOrder',
        component: () => import( '@/views/dingdmain/createMfFuwuOrder.vue'),
    },
	{
		//新建订单弹窗
		path: '/dingd/createDingd',
		component: () => import( '@/views/dingdmain/createDingd.vue'),
        meta: {
            title: '新建订单',
            isTabsPage: true,
            keepAlive: true
        }
	},
	{
	    //创建外销服务类订单
	    path: '/dingd/createWxFuwuOrder',
	    component: () => import( '@/views/dingdmain/createWxFuwuOrder.vue'),
	},
    {
        //箱单打印中英文对照表
        path: '/dingdmain/productEngTable',
        component: () => import( '@/views/dingdmain/productEngTable.vue'),
        meta: {
            title: '箱单打印中英文对照表',
            isTabsPage: true,
            keepAlive: true
        }
    },
    {
        //英国ERP物料编码与国内对照关系表
        path: '/dingdmain/productChnAndEng',
        component: () => import( '@/views/dingdmain/productChnAndEng.vue'),
        meta: {
            title: '英国ERP物料编码与国内对照关系表',
            isTabsPage: true,
            keepAlive: true
        }
    },
    {
        //经销商签收页面
        path: '/dingdmain/orderNxKaipiao',
        component: () => import( '@/views/dingdmain/OrderNxKaipiao.vue'),
        meta: {
            title:'经销商签收',
            isTabsPage: true
        }
    },
    {
        //冷库签收审批页面
        path: '/dingdmain/lkSignApprove',
        component: () => import( '@/views/dingdmain/lkSignApprove.vue'),
        meta: {
            title:'冷库签收审批页面',
        }
    },
    {
      //创建标准-组合订单
      path: '/dingd/createCombinationOrder',
      component: () => import('@/views/dingdmain/createCombinationOrder.vue'),
    },

    {
        //创建标准套餐订单那
        path: '/dingd/createPackageOrder',
        component: () => import( '@/views/dingdmain/createPackageOrder.vue'),
    },
    {
        //创建标准套餐订单那   订单关联漏斗
        path: '/dingd/createPackageOrder2',
        component: () => import( '@/views/dingdmain/createPackageOrder2.vue'),
    },
    {
        //内销订单列表
        path: '/dingd/Tcdingdlist',
        component: () => import( '@/views/dingdmain/dingd-listTc.vue'),
        meta: {
            title:'订单列表(套餐)',
            isTabsPage: true
        }
    },
    {
        //收货单位信息
        path: '/dingd/nxAddress',
        component: () => import('@/views/dingdmain/nxAddressList.vue'),
        meta: {
            title:'用户单位',
            isTabsPage: true,
            keepAlive: true
        }
    },
    {
        //收货单位信息审批
        path: '/dingd/nxAddressShenpi',
        component: () => import('@/views/dingdmain/nxAddressShenpi.vue')
    },

    {
        //二级经销商订单审批页面
        path: '/dingdmain/secondLevelOrderNxshenpi',
        component: () => import( '@/views/dingdmain/secondLevelOrderNxshenpi.vue'),
    },

    {
        //二级经销商订单列表
        path: '/dingd/secondDingdmainlist',
        component: () => import( '@/views/dingdmain/secondDingd-list.vue'),
        meta: {
            title: '分销商2.0订单列表',
            isTabsPage: true,
            keepAlive: true
        }
    },
    {
        //收货单位信息审批
        path: '/dingd/nxAddressReSubmit',
        component: () => import('@/views/dingdmain/nxAddressReSubmit.vue')
    },
    {
        path: '/invoice/paymentList',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/invoice/paymentList.vue'),
        meta: {
            title: '付款管理',
            isTabsPage: true,
            keepAlive: true
        }
    },
    {
        path: '/invoice/paymentListAdd',
        component: () => import( '@/views/invoice/paymentListAdd.vue'),
        meta: {
            title: '供应商付款审批',
            isTabsPage: true
        }
    },
    {
        //海乐苗toC订单
        path: '/dingd/hlmtocList',
        component: () => import( '@/views/dingdmain/hlmToC-list.vue'),
        meta: {
            title: '海乐苗toC订单',
            isTabsPage: true
        }
    },
    {
        //海外报关主数据
        path: '/declaration/overseaExport',
        component: () => import( '@/views/dingdmain/declaration/overseaExport.vue'),
        meta: {
            title: '海外报关主数据',
            isTabsPage: true
        }
    },
    {
        //报关草单列表
        path: '/declaration/draftDeclaration',
        component: () => import( '@/views/dingdmain/declaration/draftDeclaration.vue'),
        meta: {
            title: '报关草单',
            isTabsPage: true
        }
    },
    {
        //新增报关草单
        path: '/declaration/createDraft',
        component: () => import( '@/views/dingdmain/declaration/createDraft.vue'),
    },
    {
        //创建外贸服务订单
        path: '/dingd/createWMFwOrder',
        component: () => import( '@/views/dingdmain/createWMFwOrder.vue'),
    },
    {
        //设备公司出口报表
        path: '/dingd/exportOrder',
        component: () => import( '@/views/dingdmain/tuishuiInvoice.vue'),
        meta: {
            title: '设备公司出口报表',
            isTabsPage: true
        }
    },
    {
        //康盛订单审批页面
        path: '/dingdmain/orderWxUsashenpi',
        component: () => import( '@/views/dingdmain/orderWxshenpiUsa.vue'),
    },
    {
        //收货单位关键字信息
        path: '/dingd/addrKeywords',
        component: () => import('@/views/dingdmain/orderAddressKeywords.vue'),
        meta: {
            title:'用户单位关键字',
            isTabsPage: true,
            keepAlive: true
        }
    },
    {
        //收货单位关键字信息
        path: '/dingd/addrKeywords2',
        component: () => import('@/views/dingdmain/addrKeywords2.vue'),
        meta: {
            title:'用户单位关键字',
            isTabsPage: true,
            keepAlive: true
        }
    },
    {
        //订单列表对接国科
        path: '/dingd/dingdListGK',
        component: () => import( '@/views/dingdmain/dingdListGK.vue'),
        meta: {
            title: '订单列表(国科)',
            isTabsPage: true
        }
    },
    {
        path: '/dingd/GKInventory',
        component: () => import( '@/views/dingdmain/GKInventory.vue'),
        meta: {
            title: '国科库存',
            isTabsPage: true
        }
    },
    {
        //国科修改区域审批页面
        path: '/dingd/guokeSalesRegionShenpi',
        component: () => import( '@/views/dingd/guoke/guokeSalesRegionShenpi.vue'),
    },


    {
        //sap库存报表
        path: '/dingd/sapKucunPage',
        component: () => import( '@/views/dingd/sapKucun/sapKucunPage.vue'),
        meta: {
            title: '样品机库存报表',
            isTabsPage: true
        }
    },
    {
        //国科经销商产品限制表
        path: '/guokeAgentMaterial',
        component: () => import( '@/views/dingd/guoke/guokeAgentMaterial.vue'),
        meta: {
            title: '国科经销商产品限制表',
            isTabsPage: true
        }

    },
    {
        //国科产品调整特价历史查询
        path: '/guokeOfferAvaiLog',
        component: () => import( '@/views/dingd/guoke/guokeOfferAvaiLog.vue'),
        meta: {
            title: '国科使用特价列表',
            isTabsPage: true
        }
    },


]
